/* eslint-disable */
// @ts-nocheck

// This script is direct copy from `includes/builder/scripts/frontend/scripts.js`, aimed as an example
// of initial version of how script that is used by module is handled in D5. Further step:
// TODO feat(Refactor) Remove eslint-disable and ts-nocheck
// TODO feat(Refactor) properly convert into typescript

// External dependencies
import get from 'lodash/get';
import jQuery from 'jquery';

// Internal dependencies
import { replayPreviewModeAnimations } from '../animation/replay-preview-mode-animations';
import { bindCarouselCloneLightboxOnInit, GROUP_CAROUSEL_INIT_EVENT } from './utils/lightbox-carousel-bind';
import { waypointExtended } from '../waypoint-extended';

/*! ET frontend-builder-scripts.js */
(function ($) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { et_pb_custom } = window;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const $et_window = $(window);
  const isBlockLayoutPreview =
    'undefined' !== typeof window.ETBlockLayoutModulesScript && $('body').hasClass('et-block-layout-preview');
  const isBuilder = typeof window.ET_Builder === 'object';
  const isDiviTheme = window.et_builder_utils_params?.condition?.diviTheme === true;
  const isExtraTheme = window.et_builder_utils_params?.condition?.extraTheme === true;

  window.et_load_event_fired = false;
  window.et_is_transparent_nav = $('body').hasClass('et_transparent_nav');
  window.et_is_vertical_nav = $('body').hasClass('et_vertical_nav');
  window.et_is_fixed_nav = $('body').hasClass('et_fixed_nav');
  window.et_is_minified_js = $('body').hasClass('et_minified_js');
  window.et_is_minified_css = $('body').hasClass('et_minified_css');
  window.et_force_width_container_change = false;

  window.addEventListener('vb:preview-mode:toggled', event => {
    replayPreviewModeAnimations(Boolean(event.detail?.isActive));
  });

  jQuery.fn.reverse = [].reverse;

  /**
   * Initializes MediaElement.js audio players for Blog module audio post formats.
   * This function handles both initial page load and dynamic content (pagination).
   *
   * @since ??
   */
  const initBlogAudioContainers = () => {
    const $blogAudioContainers = $('.et_audio_content .et_audio_container');
    if ($blogAudioContainers.length === 0) {
      return;
    }

    // Use setTimeout to ensure DOM is ready and MediaElement.js is loaded.
    setTimeout(() => {
      // Check if audio script function is available.
      if (typeof window.et_pb_init_audio_modules === 'function') {
        window.et_pb_init_audio_modules();
      } else if (typeof jQuery.fn.mediaelementplayer !== 'undefined') {
        // Fallback: Initialize directly if MediaElement.js is available but script function isn't.
        $blogAudioContainers.each(function () {
          const $audioContainer = $(this);
          if ($audioContainer.find('.mejs-container').length === 0) {
            const $audio = $audioContainer.find('audio');
            if ($audio.length > 0) {
              const settings = window._wpmejsSettings;
              if (settings) {
                $audio.mediaelementplayer(settings);
              } else {
                $audio.mediaelementplayer();
              }
            }
          }
        });
      }
    }, 100);
  };

  $(window).on('et_pb_init_modules', function () {
    const et_hash_module_seperator = '||';
    const et_hash_module_param_seperator = '|';

    function process_et_hashchange(hash) {
      // Bail early when hash is empty
      if (!hash.length) {
        return;
      }

      let modules;
      let module_params;
      let element;

      if (hash.indexOf(et_hash_module_seperator, 0) !== -1) {
        modules = hash.split(et_hash_module_seperator);
        for (let i = 0; i < modules.length; i++) {
          module_params = modules[i].split(et_hash_module_param_seperator);
          element = module_params[0];
          module_params.shift();
          if (element.length && $(`#${element}`).length) {
            $(`#${element}`).trigger({
              type: 'et_hashchange',
              params: module_params,
            });
          }
        }
      } else {
        module_params = hash.split(et_hash_module_param_seperator);
        element = module_params[0];
        module_params.shift();
        if (element.length && $(`#${element}`).length) {
          $(`#${element}`).trigger({
            type: 'et_hashchange',
            params: module_params,
          });
        }
      }
    }

    $(() => {
      /**
       * Provide event listener for plugins to hook up to.
       */
      $(window).trigger('et_pb_before_init_modules');
      const $et_pb_filterable_portfolio = $('.et_pb_filterable_portfolio');
      const $et_pb_fullwidth_portfolio = $('.et_pb_fullwidth_portfolio');
      const $et_pb_gallery = $('.et_pb_gallery');
      const $et_lightbox_image = $('.et_pb_lightbox_image');
      const $et_pb_circle_counter = $('.et_pb_circle_counter');
      const $et_pb_number_counter = $('.et_pb_number_counter');
      const $et_pb_background_layout_hoverable = $('[data-background-layout][data-background-layout-hover]');
      const et_is_mobile_device =
        navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/) !== null ||
        ('standalone' in window.navigator && !window.navigator.standalone);
      const et_is_ipad = navigator.userAgent.match(/iPad/);
      const et_is_ie9 = navigator.userAgent.match(/MSIE 9.0/) !== null;
      const et_all_rows = $('.et_pb_row');
      const $et_container =
        window.et_pb_custom && !window.et_pb_custom.is_builder_plugin_used ? $('body') : et_all_rows;
      let et_container_width = $et_container.width();
      let etRecalculateOffset = false;
      const $et_sticky_image = $('.et_pb_image_sticky');
      const $et_pb_counter_amount = $('.et_pb_counter_amount');
      const $et_menu_selector =
        window.et_pb_custom && window.et_pb_custom.is_divi_theme_used ? $('ul.nav') : $('.et_pb_fullwidth_menu ul.nav');
      let et_animation_breakpoint = '';
      const recaptchaApi = get(window, 'etCore.api.spam.recaptcha');
      const et_has_audio = $('.mejs-container').length > 0;
      const et_has_fullscreen_section = $('.et_pb_fullscreen').length > 0;
      const et_pb_ab_logged_status = {};
      const grid_containers = $('.et_pb_grid_item').parent().get();
      const $hover_gutter_modules = $('.et_pb_gutter_hover');
      const $et_top_menu = $et_menu_selector;

      // Handle gutter hover options
      if ($hover_gutter_modules.length > 0) {
        $hover_gutter_modules.each(function () {
          const $thisEl = $(this);
          const originalGutter = $thisEl.data('original_gutter');
          const hoverGutter = $thisEl.data('hover_gutter');

          $thisEl
            .on('mouseenter', () => {
              $thisEl.removeClass(`et_pb_gutters${originalGutter}`);
              $thisEl.addClass(`et_pb_gutters${hoverGutter}`);
            })
            .on('mouseleave', () => {
              $thisEl.removeClass(`et_pb_gutters${hoverGutter}`);
              $thisEl.addClass(`et_pb_gutters${originalGutter}`);
            });
        });
      }

      if (et_all_rows.length) {
        et_all_rows.each(function () {
          const $this_row = $(this);
          let row_class = '';

          // Only add column structure classes for block layout rows
          if ($this_row.hasClass('et_block_row')) {
            row_class = et_get_column_types($this_row.find('>.et_pb_column'));

            if ('' !== row_class) {
              $this_row.addClass(row_class);
            }
          }

          if ($this_row.find('.et_pb_row_inner').length) {
            $this_row.find('.et_pb_row_inner').each(function () {
              const $this_row_inner = $(this);

              // Only add column structure classes for block layout row inners
              if ($this_row_inner.hasClass('et_block_row')) {
                row_class = et_get_column_types($this_row_inner.find('.et_pb_column'));

                if ('' !== row_class) {
                  $this_row_inner.addClass(row_class);
                }
              }
            });
          }

          // Fix z-index for menu modules
          const zIndexIncreaseMax = $this_row.parents('.et_pb_section.section_has_divider').length ? 6 : 4;
          const zIndexShouldIncrease = isNaN($this_row.css('z-index')) || $this_row.css('z-index') < zIndexIncreaseMax;

          if ($this_row.find('.et_pb_module.et_pb_menu').length && zIndexShouldIncrease) {
            $this_row.css('z-index', zIndexIncreaseMax);
          }
        });
      }

      function et_get_column_types($columns) {
        let row_class = '';

        if ($columns.length) {
          $columns.each(function () {
            const $column = $(this);
            const column_type = $column.attr('class').split('et_pb_column_')[1];
            const column_type_clean = typeof column_type !== 'undefined' ? column_type.split(' ', 1)[0] : '4_4';
            const column_type_updated = column_type_clean.replace('_', '-').trim();

            row_class += `_${column_type_updated}`;
          });

          if (
            row_class.indexOf('1-4') !== -1 ||
            row_class.indexOf('1-5_1-5') !== -1 ||
            row_class.indexOf('1-6_1-6') !== -1
          ) {
            switch (row_class) {
              case '_1-4_1-4_1-4_1-4':
                row_class = 'et_pb_row_4col';
                break;
              case '_1-5_1-5_1-5_1-5_1-5':
                row_class = 'et_pb_row_5col';
                break;
              case '_1-6_1-6_1-6_1-6_1-6_1-6':
                row_class = 'et_pb_row_6col';
                break;
              default:
                row_class = `et_pb_row${row_class}`;
            }
          } else {
            row_class = '';
          }
        }
        return row_class;
      }

      window.et_pb_init_nav_menu($et_top_menu);

      $et_sticky_image.each(function () {
        window.et_pb_apply_sticky_image_effect($(this));
      });

      if (et_is_mobile_device) {
        $('.et-pb-background-video').each(function () {
          const $this_el = $(this);

          $this_el.closest('.et_pb_preload').removeClass('et_pb_preload');

          // Only remove when it has opened class.
          if ($this_el.hasClass('opened')) {
            $this_el.remove();
          }
        });

        $('body').addClass('et_mobile_device');

        if (!et_is_ipad) {
          $('body').addClass('et_mobile_device_not_ipad');
        }
      }

      if (et_is_ie9) {
        $('body').addClass('et_ie9');
      }

      /**
       * Check if a video element should be visible based on CSS computed styles.
       *
       * This function checks if the video's parent wrapper (span.et-pb-background-video) is visible
       * by checking its computed display style. Lazy init and preload stripping use this alone so
       * behavior stays aligned with video.scss media queries (including tabletWide, widescreen, and
       * other suffixed variants), not et_pb_get_current_window_mode() (desktop | tablet | phone only).
       *
       * @since ??
       *
       * @param {JQuery|Element} videoElement The video as a jQuery wrapper or DOM node (normalized with `$` internally).
       *
       * @returns {boolean} True if video should be visible, false if hidden.
       */
      function isVideoVisible(videoElement: JQuery | Element): boolean {
        // Find the parent wrapper element (span.et-pb-background-video).
        // jQuery.closest returns an empty collection when there is no match; empty jQuery objects are still truthy.
        const wrapper = $(videoElement).closest('span.et-pb-background-video');

        if (!wrapper.length) {
          return false;
        }

        // Check computed style to see if element is visible.
        // video.scss uses display and media queries for all breakpoint variants (including tabletWide,
        // widescreen, ultraWide, etc.). That is the source of truth for which layer is active at the
        // current viewport — do not duplicate breakpoint names or widths here or combine with
        // et_pb_get_current_window_mode(), which only exposes a coarse desktop | tablet | phone mode.
        return wrapper.css('display') !== 'none';
      }

      /**
       * Set src attribute from data-src for a video element.
       *
       * This function sets src from data-src for all source elements in the video.
       * Only applies on frontend (not in Visual Builder).
       *
       * @since ??
       *
       * @param {JQuery<HTMLVideoElement>} $video jQuery collection whose current object is a {@link HTMLVideoElement} (matches `$(this)` from `.each()` on `find('video')`).
       *
       * @returns {void}
       */
      function setVideoSrcFromDataSrc($video: JQuery<HTMLVideoElement>): void {
        // Find all source elements within this video and set src from data-src to allow browser to load.
        $video.find('source').each(function () {
          const dataSrc = $(this).attr('data-src');

          if (dataSrc) {
            // Set src from data-src to allow browser to load.
            $(this).attr('src', dataSrc);
          }
        });
      }

      /**
       * Strip et_pb_preload when no background video in that subtree will run (nothing CSS-visible to init).
       * et_pb_video_section_init removes preload on canplay; skipped videos never fire it, so
       * ancestors would stay hidden until unrelated timeouts otherwise.
       *
       * @param {JQuery<HTMLVideoElement>} $videos Video elements for one diviElementBackgroundVideoData selector.
       *
       * @returns {void}
       */
      function removeEtPbPreloadWhenNoVideoInit($videos: JQuery<HTMLVideoElement>): void {
        if (isBuilder) {
          return;
        }

        const checkedPreloads = new Set();

        $videos.each(function () {
          const $preload = $(this).closest('.et_pb_preload');

          if (!$preload.length) {
            return;
          }

          const preloadEl = $preload[0];

          if (checkedPreloads.has(preloadEl)) {
            return;
          }

          checkedPreloads.add(preloadEl);

          const willAnyInit = $preload
            .find('video')
            .get()
            .some(videoEl => {
              const $el = $(videoEl);

              return isVideoVisible($el);
            });

          if (!willAnyInit) {
            $preload.removeClass('et_pb_preload');
          }
        });
      }

      // Initialize the background video.
      if ('undefined' !== typeof diviElementBackgroundVideoData && diviElementBackgroundVideoData.length > 0) {
        // Loop through all the background video selectors.
        $.each(diviElementBackgroundVideoData, (index, script_data) => {
          const $et_pb_video_background = $(script_data.selector).find('video');

          if ($et_pb_video_background.length && 'et_pb_video_section_init' in window) {
            $et_pb_video_background.each(function () {
              // Only apply the video data-src to src on frontend - in Visual Builder, videos should load immediately.
              // NOTE: Somehow if we use one call to `window.et_pb_video_section_init()`, the video initialization will happen to soon and fail.
              if (!isBuilder) {
                if (isVideoVisible($(this))) {
                  setVideoSrcFromDataSrc($(this));
                  window.et_pb_video_section_init($(this));
                }
              } else {
                window.et_pb_video_section_init($(this));
              }
            });

            removeEtPbPreloadWhenNoVideoInit($et_pb_video_background);
          }
        });
      }

      if (et_has_audio) {
        window.et_pb_init_audio_modules();
      }

      // Initialize audio players in Blog module posts (check for uninitialized containers).
      // This handles audio post formats in Blog module which may not be detected by et_has_audio.
      initBlogAudioContainers();

      if (!isBlockLayoutPreview && ($et_lightbox_image.length > 0 || isBuilder)) {
        window.et_pb_image_lightbox_init = function ($lightboxAnchors) {
          // Delay the initialization if magnificPopup hasn't finished loading yet.
          if (!$lightboxAnchors.magnificPopup) {
            return jQuery(window).on('load', () => {
              window.et_pb_image_lightbox_init($lightboxAnchors);
            });
          }

          const $unboundLightboxAnchors = $lightboxAnchors.filter(function () {
            const el = this;

            return !($(el).data('magnificPopup') || el.magnificPopup);
          });

          if (0 === $unboundLightboxAnchors.length) {
            return;
          }

          // Prevent attaching of any further actions on click.
          $unboundLightboxAnchors.off('click');
          $unboundLightboxAnchors.on('click');

          $unboundLightboxAnchors.magnificPopup({
            type: 'image',
            removalDelay: 500,
            mainClass: 'mfp-fade',
            zoom: {
              enabled: window.et_pb_custom && !window.et_pb_custom.is_builder_plugin_used,
              duration: 500,
              opener(element) {
                return element.find('img');
              },
            },
            autoFocusLast: false,
            callbacks: {
              open: function () {
                this.currItem.el.addClass('et_pb_lightbox_image--open');
              },
              close: function () {
                this.currItem.el.removeClass('et_pb_lightbox_image--open');
              },
            },
          });
        };

        et_pb_image_lightbox_init($et_lightbox_image);

        // Bind lightbox on Group Carousel clone slides after they are created (frontend only).
        if (!isBuilder) {
          window.addEventListener(GROUP_CAROUSEL_INIT_EVENT, event => {
            bindCarouselCloneLightboxOnInit(event, window.et_pb_image_lightbox_init);
          });
        }
      }

      if (grid_containers.length || isBuilder) {
        $(grid_containers).each(function () {
          window.et_pb_set_responsive_grid($(this), '.et_pb_grid_item');
        });
      }

      if ($('.et-pb-has-background-video').length) {
        window._wpmejsSettings.pauseOtherPlayers = false;
      }

      if ($et_pb_counter_amount.length) {
        $et_pb_counter_amount.each(function () {
          window.et_bar_counters_init($(this));
        });
      } /* $et_pb_counter_amount.length */

      $et_pb_background_layout_hoverable.each(function () {
        let $this_el = $(this);
        const background_layout = $this_el.data('background-layout');
        const background_layout_hover = $this_el.data('background-layout-hover');
        const background_layout_tablet = $this_el.data('background-layout-tablet');
        const background_layout_phone = $this_el.data('background-layout-phone');

        let $this_el_item;
        let $this_el_parent;

        // Switch the target element for some modules.
        if ($this_el.hasClass('et_pb_button_module_wrapper')) {
          // Button, change the target to main button block.
          $this_el = $this_el.find('> .et_pb_button');
        } else if ($this_el.hasClass('et_pb_gallery')) {
          // Gallery, add gallery item as target element.
          $this_el_item = $this_el.find('.et_pb_gallery_item');
          $this_el = $this_el.add($this_el_item);
        } else if ($this_el.hasClass('et_pb_post_slider')) {
          // Post Slider, add slide item as target element.
          $this_el_item = $this_el.find('.et_pb_slide');
          $this_el = $this_el.add($this_el_item);
        } else if ($this_el.hasClass('et_pb_slide')) {
          // Slider, add slider as target element.
          $this_el_parent = $this_el.closest('.et_pb_slider');
          $this_el = $this_el.add($this_el_parent);
        }

        let layout_class_list = 'et_pb_bg_layout_light et_pb_bg_layout_dark et_pb_text_color_dark';
        let layout_class = `et_pb_bg_layout_${background_layout}`;
        let layout_class_hover = `et_pb_bg_layout_${background_layout_hover}`;
        let text_color_class = 'light' === background_layout ? 'et_pb_text_color_dark' : '';
        let text_color_class_hover = 'light' === background_layout_hover ? 'et_pb_text_color_dark' : '';

        // Only includes tablet class if it's needed.
        if (background_layout_tablet) {
          layout_class_list += ' et_pb_bg_layout_light_tablet et_pb_bg_layout_dark_tablet et_pb_text_color_dark_tablet';
          layout_class += ` et_pb_bg_layout_${background_layout_tablet}_tablet`;
          layout_class_hover += ` et_pb_bg_layout_${background_layout_hover}_tablet`;
          text_color_class += 'light' === background_layout_tablet ? ' et_pb_text_color_dark_tablet' : '';
          text_color_class_hover += 'light' === background_layout_hover ? ' et_pb_text_color_dark_tablet' : '';
        }

        // Only includes phone class if it's needed.
        if (background_layout_phone) {
          layout_class_list += ' et_pb_bg_layout_light_phone et_pb_bg_layout_dark_phone et_pb_text_color_dark_phone';
          layout_class += ` et_pb_bg_layout_${background_layout_phone}_phone`;
          layout_class_hover += ` et_pb_bg_layout_${background_layout_hover}_phone`;
          text_color_class += 'light' === background_layout_phone ? ' et_pb_text_color_dark_phone' : '';
          text_color_class_hover += 'light' === background_layout_hover ? ' et_pb_text_color_dark_phone' : '';
        }

        $this_el.on('mouseenter', () => {
          $this_el.removeClass(layout_class_list);

          $this_el.addClass(layout_class_hover);

          if ($this_el.hasClass('et_pb_audio_module') && '' !== text_color_class_hover) {
            $this_el.addClass(text_color_class_hover);
          }
        });

        $this_el.on('mouseleave', () => {
          $this_el.removeClass(layout_class_list);

          $this_el.addClass(layout_class);

          if ($this_el.hasClass('et_pb_audio_module') && '' !== text_color_class) {
            $this_el.addClass(text_color_class);
          }
        });
      });

      if ('diviModuleCircleCounterReinit' in window) {
        window.diviModuleCircleCounterReinit();
      }

      if ('diviModuleChartsReinit' in window) {
        window.diviModuleChartsReinit();
      }

      if ('diviModuleNumberCounterReinit' in window) {
        window.diviModuleNumberCounterReinit();
      }

      if ('diviModuleGroupCarouselReinit' in window) {
        window.diviModuleGroupCarouselReinit();
      }

      const is_recaptcha_enabled = !isBuilder && $('.et_pb_module.et_pb_recaptcha_enabled').length > 0;
      const $recaptchaScripts = document.body.innerHTML.match(
        /<script [^>]*src="[^"].*google.com\/recaptcha\/api.js\?.*render.*"[^>]*>([\s\S]*?)<\/script>/gim,
      );
      const $diviRecaptchaScript = $('#et-recaptcha-v3-js');
      const nonDiviRecaptchaFound = $recaptchaScripts && $recaptchaScripts.length > $diviRecaptchaScript.length;

      // Make sure recaptcha badge is visible if recaptcha from 3rd party plugin found or we have module with spam protection on page
      if (!isBuilder && (nonDiviRecaptchaFound || (is_recaptcha_enabled && recaptchaApi && recaptchaApi.isEnabled()))) {
        $('body').addClass('et_pb_recaptcha_enabled');
      }

      // Contact Form Submission Script.
      if ('diviModuleContactFormInit' in window) {
        window.diviModuleContactFormInit();
      }

      if ('diviModuleSignupInit' in window) {
        window.diviModuleSignupInit();
      }

      /**
       * Returns an offset to be used for waypoints.
       *
       * @param  {element} element  The element being passed.
       * @param  {string} fallback String of either pixels or percent.
       * @returns {string}          Returns either the fallback or 'bottom-in-view'.
       */
      function et_get_offset(element, fallback) {
        // cache things so we can test.
        const section_index = element.parents('.et_pb_section').index();
        const section_length = $('.et_pb_section').length - 1;
        const row_index = element.parents('.et_pb_row').index();
        const row_length = element.parents('.et_pb_section').children().length - 1;

        // return bottom-in-view if it is the last element otherwise return the user defined fallback
        if (section_index === section_length && row_index === row_length) {
          return 'bottom-in-view';
        }
        return fallback;
      }

      /**
       * Reinit animation styles on window resize.
       *
       * It will check current window mode then compare it with the breakpoint of last rendered
       * animation styles. If it's different, it will recall window.et_process_animation_data().
       *
       * @since 3.23
       */
      function et_pb_reinit_animation() {
        // If mode is changed, reinit animation data.
        if (et_pb_get_current_window_mode() !== et_animation_breakpoint) {
          if (typeof window.et_process_animation_data === 'function') {
            window.et_process_animation_data(false);
          }
        }
      }

      window.et_reinit_waypoint_modules = et_pb_debounce(() => {
        const $et_pb_circle_counter = $('.et_pb_circle_counter');
        const $et_pb_number_counter = $('.et_pb_number_counter');

        // if waypoint is available and we are not ignoring them.
        if ($.fn.waypoint && window.et_pb_custom && 'yes' !== window.et_pb_custom.ignore_waypoints && !isBuilder) {
          if (typeof window.et_process_animation_data === 'function') {
            window.et_process_animation_data(true);
          }

          // get all of our waypoint things.
          const modules = $('.et-waypoint');
          modules.each(function () {
            waypointExtended(
              $(this),
              {
                offset: et_get_offset($(this), '100%'),
                handler() {
                  // what actually triggers the animation.
                  $(this.element).addClass('et-animated');
                },
              },
              2,
            );
          });

          // Set waypoint for circle counter module.
          if ($et_pb_circle_counter.length) {
            // iterate over each.
            $et_pb_circle_counter.each(function () {
              const $this_counter = $(this).find('.et_pb_circle_counter_inner');
              if (
                !$this_counter.is(':visible') ||
                ('function' === typeof window.et_has_animation_data && window.et_has_animation_data($this_counter))
              ) {
                return;
              }

              waypointExtended(
                $this_counter,
                {
                  offset: et_get_offset($(this), '100%'),
                  handler() {
                    if (
                      $this_counter.data('easyPieChartAnimating') ||
                      $this_counter.data('PieChartHasLoaded') ||
                      'undefined' === typeof $this_counter.data('easyPieChart')
                    ) {
                      return;
                    }

                    // No need to update animated circle counter as soon as it hits
                    // bottom of the page in layout block preview page since layout
                    // block preview page is being rendered in 100% height inside
                    // Block Editor
                    if (isBlockLayoutPreview) {
                      return;
                    }

                    $this_counter.data('easyPieChart').triggerAnimation();

                    $this_counter.data('PieChartHasLoaded', true);
                  },
                },
                2,
              );
            });
          }

          // Set waypoint for number counter module.
          if ($et_pb_number_counter.length) {
            $et_pb_number_counter.each(function () {
              const $this_counter = $(this);

              if ('function' === typeof window.et_has_animation_data && window.et_has_animation_data($this_counter)) {
                return;
              }

              waypointExtended($this_counter, {
                offset: et_get_offset($(this), '100%'),
                handler() {
                  if (
                    !$this_counter.data('easyPieChartAnimating') &&
                    !$this_counter.data('PieChartHasLoaded') &&
                    'undefined' !== typeof $this_counter.data('easyPieChart')
                  ) {
                    $this_counter.data('easyPieChart').triggerAnimation();
                    $this_counter.data('PieChartHasLoaded', true);
                  }
                },
              });
            });
          }
        } else {
          // if no waypoints supported then apply all the animations right away
          if (typeof window.et_process_animation_data === 'function') {
            window.et_process_animation_data(false);
          }
          const animated_class = isBuilder ? 'et-animated--vb' : 'et-animated';

          $('.et-waypoint').addClass(animated_class);

          // While in the builder, trigger all animations instantly as otherwise
          // TB layouts that are displayed but are not the currently edited post
          // will have their animated modules invisible due to .et-waypoint.
          $('.et-waypoint').each(function () {
            window.et_animate_element($(this));
          });

          if ($et_pb_circle_counter.length) {
            $et_pb_circle_counter.each(function () {
              const $this_counter = $(this).find('.et_pb_circle_counter_inner');

              if (!$this_counter.is(':visible')) {
                return;
              }

              if (
                $this_counter.data('easyPieChartAnimating') ||
                $this_counter.data('PieChartHasLoaded') ||
                'undefined' === typeof $this_counter.data('easyPieChart')
              ) {
                return;
              }

              $this_counter.data('easyPieChart').triggerAnimation();

              $this_counter.data('PieChartHasLoaded', true);
            });
          }

          // In VB (isBuilder = true), Number Counter animation is handled by the React component.
          // Do not call triggerAnimation() here as it would re-animate counters that have already
          // been initialized and animated by the React component's numberCounterInit.
          // This matches D4's behavior where fixBuilderContent calls update() (not triggerAnimation())
          // and D4's update() uses disableAnimation() before updating.
        } // End checking of waypoints.

        // Init waypoints for the background video.
        if ('undefined' !== typeof diviElementBackgroundVideoData && diviElementBackgroundVideoData.length > 0) {
          // Loop through all the background video selectors.
          $.each(diviElementBackgroundVideoData, (index, script_data) => {
            const $et_pb_video_background = $(script_data.selector).find('video');

            if ($et_pb_video_background.length && 'et_pb_video_background_init' in window) {
              $et_pb_video_background.each(function () {
                window.et_pb_video_background_init($(this), this);
              });
            }
          });
        }

        // End of et_pb_debounce().
      }, 100);

      /**
       * Get current active device based on window width size.
       *
       * @returns {string} View mode.
       */
      function et_pb_get_current_window_mode() {
        const window_width = $et_window.width();
        let current_mode = 'desktop';

        if (window_width <= 980 && window_width > 767) {
          current_mode = 'tablet';
        } else if (window_width <= 767) {
          current_mode = 'phone';
        }

        return current_mode;
      }

      function et_pb_set_cookie_expire(days) {
        const ms = days * 24 * 60 * 60 * 1000;

        const date = new Date();
        date.setTime(date.getTime() + ms);

        return `; expires=${date.toUTCString()}`;
      }

      function et_pb_check_cookie_value(cookie_name, value) {
        return et_pb_get_cookie_value(cookie_name) == value;
      }

      function et_pb_get_cookie_value(cookie_name) {
        return et_pb_parse_cookies()[cookie_name];
      }

      function et_pb_parse_cookies() {
        const cookies = document.cookie.split('; ');

        const ret = {};
        for (let i = cookies.length - 1; i >= 0; i--) {
          const el = cookies[i].split('=');
          ret[el[0]] = el[1];
        }
        return ret;
      }

      function et_pb_set_cookie(expire, cookie_content) {
        const cookie_expire = et_pb_set_cookie_expire(expire);
        document.cookie = `${cookie_content + cookie_expire}; path=/`;
      }

      let resizeTimeout;
      $(window).on('resize', () => {
        const window_width = $et_window.width();
        const et_container_css_width = $et_container.css('width');
        const et_container_width_in_pixel =
          typeof et_container_css_width !== 'undefined' ? et_container_css_width.substr(-1, 1) !== '%' : '';
        const et_container_actual_width = et_container_width_in_pixel
          ? $et_container.width()
          : ($et_container.width() / 100) * window_width; // $et_container.width() doesn't recognize pixel or percentage unit. It's our duty to understand what it returns and convert it properly
        window.containerWidthChanged = et_container_width !== et_container_actual_width;
        const $dividers = $('.et_pb_top_inside_divider, .et_pb_bottom_inside_divider');

        if ('undefined' !== typeof diviElementBackgroundVideoData && diviElementBackgroundVideoData.length > 0) {
          // Loop through all the background video selectors.
          $.each(diviElementBackgroundVideoData, (index, script_data) => {
            const $et_pb_video_background = $(script_data.selector).find('video');

            // Resize the background video.
            if ($et_pb_video_background.length && 'et_pb_resize_section_video_bg' in window) {
              $et_pb_video_background.each(function () {
                window.et_pb_resize_section_video_bg($(this));
              });
            }

            // Center the background video.
            if ($et_pb_video_background.length && 'et_pb_center_video' in window) {
              $et_pb_video_background.each(function () {
                window.et_pb_center_video($(this));
              });
            }

            // Handle viewport changes: Initialize videos that CSS now shows but have not been data-src promoted yet.
            // Only on frontend (not in Visual Builder) where we use data-src pattern.
            if ($et_pb_video_background.length && 'et_pb_video_section_init' in window && !isBuilder) {
              $et_pb_video_background.each(function () {
                const $video = $(this);
                // Check if video has data-src but no src (not yet initialized).
                const hasDataSrc = $video.find('source[data-src]').length > 0;
                const hasSrc = $video.find('source[src]').length > 0;

                // If the wrapper is CSS-visible but has not been initialized yet.
                if (hasDataSrc && !hasSrc && isVideoVisible($video)) {
                  setVideoSrcFromDataSrc($video);
                  window.et_pb_video_section_init($video);
                }
              });

              removeEtPbPreloadWhenNoVideoInit($et_pb_video_background);
            }
          });
        }

        $et_pb_fullwidth_portfolio.each(function () {
          const set_container_height = !!$(this).hasClass('et_pb_fullwidth_portfolio_carousel');
          window.set_fullwidth_portfolio_columns($(this), set_container_height);
        });

        if (containerWidthChanged || window.et_force_width_container_change) {
          $('.container-width-change-notify').trigger('containerWidthChanged');

          setTimeout(() => {
            $et_pb_filterable_portfolio.each(function () {
              window.set_filterable_grid_items($(this));
            });
            $et_pb_gallery.each(function () {
              if ($(this).hasClass('et_pb_gallery_grid')) {
                set_gallery_grid_items($(this));
              }
            });
          }, 100);

          et_container_width = et_container_actual_width;

          etRecalculateOffset = true;

          if (resizeTimeout) {
            clearTimeout(resizeTimeout);
          }

          resizeTimeout = setTimeout(() => {
            if ('diviModuleCircleCounterReinit' in window) {
              window.diviModuleCircleCounterReinit();
            }
            if ('diviModuleChartsReinit' in window) {
              window.diviModuleChartsReinit();
            }
            if ('diviModuleNumberCounterReinit' in window) {
              window.diviModuleNumberCounterReinit();
            }
          }, 500);

          // Reset to false
          window.et_force_width_container_change = false;
        }

        if ($et_pb_counter_amount.length) {
          $et_pb_counter_amount.each(function () {
            window.et_bar_counters_init($(this));
          });
        } /* $et_pb_counter_amount.length */

        // Reinit animation.
        isBuilder && et_pb_reinit_animation();

        if (grid_containers.length || isBuilder) {
          $(grid_containers).each(function () {
            window.et_pb_set_responsive_grid($(this), '.et_pb_grid_item');
          });
        }

        // Re-apply module divider fix
        if (!isBuilder && $dividers.length) {
          $dividers.each(function () {
            etFixDividerSpacing($(this));
          });
        }

        if (!isBuilder && typeof window.fitvids_slider_fullscreen_init === 'function') {
          fitvids_slider_fullscreen_init();
        }
      });

      function et_pb_window_load_scripts() {
        if (et_has_fullscreen_section) {
          window.et_fix_fullscreen_section();
          window.et_calculate_fullscreen_section_size();
        }

        setTimeout(() => {
          $('.et_pb_preload').removeClass('et_pb_preload');
        }, 500);

        // Since modern browsers already support `hashchange` event, we drop jQuery
        // hashchange library usage here and use Javascript hashchange instead.
        if (window.HashChangeEvent) {
          $(window).on('hashchange', () => {
            const hash = window.location.hash.replace(/[^a-zA-Z0-9-_|]/g, '');
            process_et_hashchange(hash);
          });
          $(window).trigger('hashchange');
        }

        if ('diviElementBackgroundParallaxInit' in window) {
          // reinit parallax on slide change to make sure it displayed correctly
          window.diviElementBackgroundParallaxInit();
        }

        window.et_reinit_waypoint_modules();

        // Initialize audio players in Blog module posts (pagination/dynamic content).
        initBlogAudioContainers();

        if ($('.et_audio_content').length) {
          $(window).trigger('resize');
        }
      }

      if (window.et_load_event_fired) {
        et_pb_window_load_scripts();
      } else {
        $(window).on('load', () => {
          et_pb_window_load_scripts();
        });
      }

      if ($('.et_section_specialty').length) {
        $('.et_section_specialty').each(function () {
          const this_row = $(this).find('.et_pb_row');

          this_row.find('>.et_pb_column:not(.et_pb_specialty_column)').addClass('et_pb_column_single');
        });
      }

      // Wait the page fully loaded to make sure all the css applied before calculating sizes
      const previousCallback = document.onreadystatechange || function () {};
      document.onreadystatechange = function () {
        if ('complete' === document.readyState) {
          window.et_fix_pricing_currency_position();
        }

        previousCallback();
      };

      // Play the background video on hover.
      if ('undefined' !== typeof diviElementBackgroundVideoData && diviElementBackgroundVideoData.length > 0) {
        // Loop through all the background video selectors.
        $.each(diviElementBackgroundVideoData, (index, script_data) => {
          const $et_pb_video_background = $(script_data.selector).find('video');

          if ($et_pb_video_background.length && 'et_pb_background_video_on_hover' in window) {
            $et_pb_video_background.each(function () {
              window.et_pb_background_video_on_hover($(this));
            });
          }
        });
      }

      /**
       * Provide event listener for plugins to hook up to.
       */
      $(document).trigger('et_pb_after_init_modules');
    });

    if ('diviModuleBlogGridInit' in window) {
      if (window.et_load_event_fired) {
        window.diviModuleBlogGridInit();
      } else {
        $(window).on('load', () => {
          window.diviModuleBlogGridInit();
        });
      }
    }
  });

  // Wrapped in a function to prevent `window.et_pb_init_modules is not a function`
  window.et_pb_init_modules = function () {
    $(window).trigger('et_pb_init_modules');
  };

  function et_get_first_section() {
    return $('.et-l:not(.et-l--footer) .et_pb_section:visible').first();
  }

  if (
    window.et_pb_custom &&
    window.et_pb_custom.is_ab_testing_active &&
    'yes' === window.et_pb_custom.is_cache_plugin_active
  ) {
    // update the window.et_load_event_fired variable to initiate the scripts properly
    $(window).on('load', () => {
      window.et_load_event_fired = true;
    });

    let pendingRequests = et_pb_custom.ab_tests.length;

    $.each(et_pb_custom.ab_tests, (index, test) => {
      // get the subject id for current visitor and display it
      // this ajax request performed only if AB Testing is enabled and cache plugin active
      $.ajax({
        type: 'POST',
        url: et_pb_custom.ajaxurl,
        dataType: 'json',
        data: {
          action: 'et_pb_ab_get_subject_id',
          et_frontend_nonce: et_pb_custom.et_frontend_nonce,
          et_pb_ab_test_id: test.post_id,
        },
        success(subject_data) {
          if (subject_data) {
            // Append the subject content to appropriate placeholder.
            const $placeholder = $(`.et_pb_subject_placeholder_id_${test.post_id}_${subject_data.id}`);
            $placeholder.after(subject_data.content);
            $placeholder.remove();
          }

          pendingRequests -= 1;

          if (pendingRequests <= 0) {
            // remove all other placeholders from the DOM
            $('.et_pb_subject_placeholder').remove();

            // init all scripts once the subject loaded
            window.et_pb_init_modules();
            $('body').trigger('et_pb_ab_subject_ready');
          }
        },
      });
    });
  } else {
    window.et_pb_init_modules();
  }

  /**
   * Fix anchor scrolling to position.
   *
   * @since 4.6.6
   */
  function et_pb_fix_scroll_to_anchor_position() {
    window.et_location_hash = window.location.hash.replace(/[^a-zA-Z0-9-_#]/g, '');

    if ('' === window.et_location_hash) {
      return;
    }

    // Prevent jump to anchor - Firefox
    window.scrollTo(0, 0);

    let anchoredElement;
    try {
      anchoredElement = $(window.et_location_hash);
    } catch {
      anchoredElement = $();
    }

    if (!anchoredElement.length) {
      return;
    }

    // bypass auto scrolling, if supported
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    } else {
      // Prevent jump to anchor - Other Browsers
      window.et_location_hash_style = anchoredElement.css('display');
      anchoredElement.css('display', 'none');
    }
  }

  document.addEventListener('readystatechange', () => {
    // Enable alternative scroll to anchor method only for Divi and Extra.
    if ('complete' === document.readyState && (isDiviTheme || isExtraTheme)) {
      et_pb_fix_scroll_to_anchor_position();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    // Hover transition are disabled for section dividers to prevent visual glitches while document is loading,
    // we can enable them again now. Also, execute unwanted divider spacing
    $('.et_pb_top_inside_divider.et-no-transition, .et_pb_bottom_inside_divider.et-no-transition')
      .removeClass('et-no-transition')
      .each(function () {
        etFixDividerSpacing($(this));
      });

    // Set a delay just to make sure all modules are ready before we append box shadow container.
    // Similar approach exists on VB custom CSS output.
    setTimeout(() => {
      (window.et_pb_box_shadow_elements || []).map(et_pb_box_shadow_apply_overlay);
    }, 0);
  });

  $(window).on('load', () => {
    const $body = $('body');

    // set load event here because safari sometimes will not run load events registered on et_pb_init_modules.
    window.et_load_event_fired = true;

    // fix Safari letter-spacing bug when styles applied in `head`
    // Trigger styles redraw by changing body display property to differentvalue and reverting it back to original.
    if ($body.hasClass('safari')) {
      const original_display_value = $body.css('display');
      const different_display_value = 'initial' === original_display_value ? 'block' : 'initial';

      $body.css({ display: different_display_value });

      setTimeout(() => {
        $body.css({ display: original_display_value });
      }, 0);

      // Keep this script here, as it needs to be executed only if the script from above is executed
      // As the script from above somehow affects WooCommerce single product image rendering.
      // https://github.com/elegantthemes/Divi/issues/7454
      if ($body.hasClass('woocommerce-page') && $body.hasClass('single-product')) {
        const $wc = $('.woocommerce div.product div.images.woocommerce-product-gallery');

        if (0 === $wc.length) {
          return;
        }

        // Don't use jQuery to get element opacity, as it may return an outdated value.
        const opacity = parseInt($wc[0].style.opacity);

        if (!opacity) {
          return;
        }

        $wc.css({ opacity: opacity - 0.09 });
        setTimeout(() => {
          $wc.css({ opacity });
        }, 0);
      }
    }
  });

  // Handle cases where builder modules are not initially visible and produce sizing
  // issues as a result (e.g. slider module inside popups, accordions etc.).
  $(() => {
    if (MutationObserver === undefined) {
      // Bail if MutationObserver is not supported by the user agent.
      return;
    }

    const getSectionParents = function ($sections) {
      const filterMethod = $.uniqueSort !== undefined ? $.uniqueSort : $.unique;
      let $sectionParents = $([]);

      $sections.each(function () {
        $sectionParents = $sectionParents.add($(this).parents());
      });

      // Avoid duplicate section parents.
      return filterMethod($sectionParents.get());
    };

    const getInvisibleNodes = function ($sections) {
      return $sections.filter(function () {
        return !$(this).is(':visible');
      }).length;
    };

    const $sections = $('.et_pb_section');
    const sectionParents = getSectionParents($sections);
    let invisibleSections = getInvisibleNodes($sections);
    const maybeRefreshSections = function () {
      const newInvisibleSections = getInvisibleNodes($sections);
      if (newInvisibleSections < invisibleSections) {
        // Trigger resize if some previously invisible sections have become visible.
        $(window).trigger('resize');
      }
      invisibleSections = newInvisibleSections;
    };
    const observer = new MutationObserver(window.et_pb_debounce(maybeRefreshSections, 200));

    for (let i = 0; i < sectionParents.length; i++) {
      observer.observe(sectionParents[i], {
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
        attributeOldValue: false,
        characterData: false,
        characterDataOldValue: false,
        subtree: false,
      });
    }
  });
})(jQuery);
